/** Serialize writes to the same record, without preventing writes to other records.
 * Callers capture immutable payloads and scope before enqueueing. Failed writes do not
 * prevent a subsequent correction from saving.
 */
export function createSaveQueue() {
  const pending = new Map<string, Promise<unknown>>();
  return function enqueue<T>(key: string, write: () => Promise<T>): Promise<T> {
    const result = (pending.get(key) ?? Promise.resolve()).catch(() => undefined).then(write);
    pending.set(key, result);
    const clear = () => {
      if (pending.get(key) === result) pending.delete(key);
    };
    void result.then(clear, clear);
    return result;
  };
}
